import classes from './titleSection.module.scss';
export const TitleSection = ({ children }) => {
    return <div className={classes.titleSection}>{children}</div>;
};
